export default "__VITE_ASSET__Co2IAcE0__"